import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReqBodyBuscaListadoReportes, IResListadoReportes } from 'src/app/interfaces/reporte-consulta-estado-seccion';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReporteConsultaEstadoSeccionService {
  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders{
    return new HttpHeaders();
  }
  
  getListadoReportes(anyo: number, periodoId: number, sedeId:number, asignaturaId: number = 0, docenteId: number = 0): Observable<IResListadoReportes> {
    const reqBody: IReqBodyBuscaListadoReportes = {anyo, periodoId, sedeId, asignaturaId, docenteId}
    const url = `${environment.endpointAdministrativo}/v1/reporte-consulta-estado-seccion/buscaListadoReportes`
    return this.http.post<IResListadoReportes>(url, reqBody, { headers: this.getHeaders() })
  }

  postGeneraSolicitudReporte(anyo: number, periodoId: number, sedeId:number, asignaturaId: number = 0, docenteId: number = 0): Observable<IResListadoReportes> {
    const reqBody: IReqBodyBuscaListadoReportes = {anyo, periodoId, sedeId, asignaturaId, docenteId}
    const url = `${environment.endpointAdministrativo}/v1/reporte-consulta-estado-seccion/generaSolicitudReporte`
    return this.http.post<IResListadoReportes>(url, reqBody, { headers: this.getHeaders() })
  }

  getDescargaReporte(idReporte: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-consulta-estado-seccion/obtener-reporte-bytes?idSolicitudReporte=${idReporte}`
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }
}
